import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_180: DocMigration = {
  maxSchemaVersion: "0.0.180",
  description: "Pull includeDriveway out of params to door descriptor and door placement as field",
  apply(json: any) {
    if (json.settings) {
      for (const settingId in json.settings) {
        const setting = json.settings[settingId];

        if (setting.type !== "DOOR_CATALOG_SETTINGS") {
          continue;
        }

        for (const doorTypeId in setting.doorTypes) {
          const doorType = setting.doorTypes[doorTypeId];
          if (!doorType.params) {
            continue;
          }

          const includeDriveway = doorType.params.includeDriveway;
          if (includeDriveway !== undefined) {
            doorType.includeDriveway = includeDriveway;
          }
          delete doorType.params;
        }
      }
    }

    for (const id in json.roomLayouts) {
      const roomLayout = json.roomLayouts[id];

      if (!roomLayout.openingPatterns?.length) {
        continue;
      }

      for (const openingPattern of roomLayout.openingPatterns) {
        if (openingPattern.openings) {
          for (const opening of openingPattern.openings) {
            if (!opening.paramValues) {
              continue;
            }

            const includeDriveway = opening.paramValues.includeDriveway;
            if (includeDriveway !== undefined) {
              opening.includeDriveway = includeDriveway;
              delete opening.paramValues.includeDriveway;
            }
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_180;
